<script setup lang="ts">

import Skeleton from "../Skeleton.vue";
import {useCartStore} from "../../stores/cart.ts";

const cartStore = useCartStore()

</script>

<template>
    <Skeleton class="w-12" v-if="cartStore.isLoading"/>
    <template v-else>
        <slot/>
    </template>
</template>
